var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"py-0 pt-3",attrs:{"fluid":""}},[_c('Breadcrumbs')],1),_c('tiles-page',{attrs:{"title":"База знаний","link-groups":_vm.linkGroups,"sm":"12","md":"6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }